import { format } from "date-fns";
import { Timestamp } from "firebase/firestore";

// ✅ ARQUIVO CARREGADO - VERSÃO CORRIGIDA - 2025-12-15 15:01
// console.log('🔥 [UTILS historicoGraduacoesUtil.js] ARQUIVO CARREGADO - VERSÃO CORRIGIDA ATIVA');

const getEmpty_historicoGraduacoes = () => {
  return ["", "", "", "", "", "", "", "", "", "", {}, {}, {}, {}, {}, {}, {}, {}, {}];
};

export const convert_historicoGraduacoesValuesFromTimestamp = (historicoGraduacoes, HistoricoGraduacoes) => {
  // console.log("convert_historicoGraduacoesValuesFromTimestamp => HistoricoGraduacoes:", HistoricoGraduacoes);
  // console.log("convert_historicoGraduacoesValuesFromTimestamp => historicoGraduacoes:", historicoGraduacoes);

  // Se historicoGraduacoes for undefined, inicialize com valores padrão
  if (!historicoGraduacoes) {
    historicoGraduacoes = getEmpty_historicoGraduacoes();
    
    // Se HistoricoGraduacoes for definido, use-o para popular historicoGraduacoes
    if (HistoricoGraduacoes && Array.isArray(HistoricoGraduacoes)) {
      try {
        for (let indxGraduacao = 0; indxGraduacao < HistoricoGraduacoes.length; indxGraduacao++) {
          const graduacao = HistoricoGraduacoes[indxGraduacao];
          
          if (indxGraduacao <= 9) {
            historicoGraduacoes[indxGraduacao] = graduacao || "";
          }
          else {
            historicoGraduacoes[indxGraduacao] = {
              nivel: indxGraduacao,
              data: graduacao || "",
              aprovacaoFederacao: graduacao !== undefined && graduacao !== "",
              observacaoFederacao: "",
              aprovacaoConfederacao: graduacao !== undefined && graduacao !== "",
              observacaoConfederacao: "",
              comprovanteAnexo: "",
            };
          }
        }
      } catch (error) {
        console.error("convert_historicoGraduacoesValuesFromTimestamp => error:", error);
        // Em caso de erro, garantir que historicoGraduacoes seja inicializado corretamente
        historicoGraduacoes = getEmpty_historicoGraduacoes();
      }
    }
  }

  // Garantir que historicoGraduacoes é um array
  if (!Array.isArray(historicoGraduacoes)) {
    historicoGraduacoes = getEmpty_historicoGraduacoes();
  }

  // Garantir que temos exatamente 19 elementos no array
  if (historicoGraduacoes.length < 19) {
    const vazios = getEmpty_historicoGraduacoes().slice(historicoGraduacoes.length);
    historicoGraduacoes = [...historicoGraduacoes, ...vazios];
  }

  historicoGraduacoes = historicoGraduacoes.slice(0, 19);
  historicoGraduacoes = historicoGraduacoes.map((historicoGraduacao, indxGraduacao) => {
    // Se o item é undefined ou null, retorna valor padrão
    if (historicoGraduacao === undefined || historicoGraduacao === null) {
      return indxGraduacao <= 9 ? "" : {};
    }
    
    if (indxGraduacao <= 9) {
      if (Object.keys(historicoGraduacao).length === 0) return "";

      // ✅ Tipo STRING (modelo antigo): retorna diretamente
      if (typeof historicoGraduacao === "string") {
        if (historicoGraduacao === "") return historicoGraduacao;
        return historicoGraduacao;
      } else {
        // ✅ Tipo OBJECT (modelo NOVO com campos completos): preservar TODOS os campos
        // console.log('🔧 [UTILS - OBJECT BRANCH] Índice:', indxGraduacao, '| Campos recebidos:', Object.keys(historicoGraduacao));
        
        // ✅ CORREÇÃO CRÍTICA: Processar campo data corretamente quando é Timestamp
        let dataFormatada = "";
        if (historicoGraduacao.data !== undefined && historicoGraduacao.data !== "") {
          // data existe e não é vazia
          if (typeof historicoGraduacao.data === 'string') {
            // Já é string, manter
            dataFormatada = historicoGraduacao.data;
          } else if (historicoGraduacao.data && typeof historicoGraduacao.data.toDate === 'function') {
            // É Timestamp com método toDate()
            dataFormatada = format(historicoGraduacao.data.toDate(), "yyyy-MM-dd");
          } else if (historicoGraduacao.data && historicoGraduacao.data.seconds !== undefined) {
            // É Timestamp com propriedade seconds (Firestore)
            const timestampSeconds = historicoGraduacao.data.seconds;
            const timestampDate = new Date(timestampSeconds * 1000);
            const ano = timestampDate.getUTCFullYear();
            const mes = timestampDate.getUTCMonth();
            const dia = timestampDate.getUTCDate();
            const dataAjustada = new Date(Date.UTC(ano, mes, dia, 12, 0, 0));
            dataFormatada = format(dataAjustada, "yyyy-MM-dd");
          } else {
            // Formato desconhecido
            console.warn('⚠️ [UTILS] Formato de data não reconhecido:', historicoGraduacao.data);
            dataFormatada = "";
          }
        }
        
        // ✅ RETORNAR OBJETO COMPLETO COM TODOS OS CAMPOS (NÃO apenas string de data)
        return {
          data: dataFormatada,
          comprovanteAnexo: historicoGraduacao.comprovanteAnexo || "",
          aprovacaoFederacao: historicoGraduacao.aprovacaoFederacao !== undefined ? historicoGraduacao.aprovacaoFederacao : (dataFormatada !== ""),
          aprovacaoConfederacao: historicoGraduacao.aprovacaoConfederacao !== undefined ? historicoGraduacao.aprovacaoConfederacao : false,
          cidadeExame: historicoGraduacao.cidadeExame || "",
          mestreExaminador: historicoGraduacao.mestreExaminador || "",
          mestreExaminadorID: historicoGraduacao.mestreExaminadorID || "",
          nivel: indxGraduacao,
          observacaoFederacao: historicoGraduacao.observacaoFederacao || "",
          professorID: historicoGraduacao.professorID || "",
          professor: historicoGraduacao.professor || "",
        };
      }
    }
    
    
    // ✅ POSIÇÕES DAN (10-18): processamento de objetos completos
    if (indxGraduacao > 9) {
      if (Object.keys(historicoGraduacao).length === 1) {
        historicoGraduacao = {
          nivel: indxGraduacao + 1,
          data: "",
          aprovacaoFederacao: false,
          observacaoFederacao: "",
          aprovacaoConfederacao: false,
          observacaoConfederacao: "",
          comprovanteAnexo: "",
          ...historicoGraduacao
        }
      }

      if (typeof historicoGraduacao.data === "string") return historicoGraduacao;
      else if (historicoGraduacao.data !== "") {
        // Ajuste para fuso horário brasileiro (GMT-3)
        // console.log("convert_historicoGraduacoesValuesFromTimestamp => historicoGraduacao.data:", historicoGraduacao.data);

        try {
          const timestamp = historicoGraduacao.data;

          // Verifica se é um timestamp válido do Firestore
          if (timestamp && timestamp.seconds !== undefined && timestamp.nanoseconds !== undefined) {
            // Converter para milissegundos
            const timestampSeconds = timestamp.seconds;
            const timestampDate = new Date(timestampSeconds * 1000);

            // Calculamos a data UTC
            const ano = timestampDate.getUTCFullYear();
            const mes = timestampDate.getUTCMonth();
            const dia = timestampDate.getUTCDate();

            // Criar uma nova data usando UTC para evitar confusão de timezone
            const dataAjustada = new Date(Date.UTC(ano, mes, dia, 12, 0, 0)); // Meio-dia UTC

            // console.log(`convert_historicoGraduacoesValuesFromTimestamp => Original=${timestampDate.toISOString()}, Ajustada=${dataAjustada.toISOString()}`);

            historicoGraduacao.data = format(dataAjustada, "yyyy-MM-dd");
            // console.log("convert_historicoGraduacoesValuesFromTimestamp => historicoGraduacao.data formatada:", historicoGraduacao.data);
            return historicoGraduacao;
          } else if (timestamp && typeof timestamp.toDate === 'function') {
            // Método alternativo para objetos com método toDate
            const date = timestamp.toDate();
            const ano = date.getFullYear();
            const mes = date.getMonth();
            const dia = date.getDate();

            // Criar data UTC para evitar problemas de timezone
            const dataAjustada = new Date(Date.UTC(ano, mes, dia, 12, 0, 0)); // Meio-dia UTC

            historicoGraduacao.data = format(dataAjustada, "yyyy-MM-dd");
            return historicoGraduacao;
          } else {
            // Verificar se é undefined ou null antes de logar o warning
            if (historicoGraduacao.data !== undefined && historicoGraduacao.data !== null) {
              console.warn("Formato de data desconhecido:", historicoGraduacao.data);
            }
            return historicoGraduacao;
          }
        } catch (error) {
          console.error("Erro ao converter data:", error, historicoGraduacao);
          return historicoGraduacao;
        }
      }
      else return historicoGraduacao;
    }
  });
  // console.log("convert_historicoGraduacoesValuesFromTimestamp => final => historicoGraduacoes:", historicoGraduacoes);
  return historicoGraduacoes;
};


export const convert_historicoGraduacoesValuesToTimestamp = (historicoGraduacoes) => {
  // console.log("convert_historicoGraduacoesValuesToTimestamp => historicoGraduacoes:", historicoGraduacoes);

  /**
   * Função para converter uma data string para timestamp considerando o fuso GMT-3 brasileiro
   * @param {string} dataString - Data no formato "YYYY-MM-DD"
   * @returns {Timestamp} - Timestamp do Firestore ajustado para GMT-3
   */
  const converterParaTimestampBrasil = (dataString) => {
    if (!dataString) return dataString;

    try {
      // Nova abordagem: criar data usando UTC para evitar problemas de fuso horário
      // Formato esperado para dataString: "YYYY-MM-DD"
      const parts = dataString.split('-');
      if (parts.length !== 3) {
        console.error("Formato de data inválido:", dataString);
        return Timestamp.fromDate(new Date());
      }

      // Parse dos componentes da data
      const year = parseInt(parts[0]);
      const month = parseInt(parts[1]) - 1; // JS meses são 0-indexed
      const day = parseInt(parts[2]);

      if (isNaN(year) || isNaN(month) || isNaN(day)) {
        console.error("Valores de data inválidos:", { year, month, day });
        return Timestamp.fromDate(new Date());
      }

      // Criar data em UTC para manter consistência com a leitura
      const utcDate = new Date(Date.UTC(year, month, day, 12, 0, 0)); // Meio-dia UTC
      // console.log("UTC Date criada:", utcDate.toISOString());

      return Timestamp.fromDate(utcDate);
    } catch (error) {
      console.error("Erro ao converter para timestamp:", error);
      return Timestamp.fromDate(new Date());
    }
  };

  let returnValue = historicoGraduacoes.map((historicoGraduacao, indxGraduacao) => {
    if (indxGraduacao <= 9) {
      if (typeof historicoGraduacao === "string" && historicoGraduacao !== "") {
        // console.log("convert_historicoGraduacoesValuesToTimestamp => Opção 1: historicoGraduacao:", historicoGraduacao, indxGraduacao, converterParaTimestampBrasil(historicoGraduacao));

        // Usar a função de conversão com ajuste para GMT-3
        return converterParaTimestampBrasil(historicoGraduacao);
      }
      else return historicoGraduacao;
    } else {
      if (historicoGraduacao.data === undefined) historicoGraduacao.data = "";
      if (typeof historicoGraduacao.data === "string" && historicoGraduacao.data !== "") {
        // console.log("convert_historicoGraduacoesValuesToTimestamp => Opção 2: historicoGraduacao.data:", historicoGraduacao.data, indxGraduacao, converterParaTimestampBrasil(historicoGraduacao.data));

        // Usar a função de conversão com ajuste para GMT-3
        historicoGraduacao.data = converterParaTimestampBrasil(historicoGraduacao.data);
        return historicoGraduacao;
      }
      else
        return historicoGraduacao;
    }
  });
  // console.log("convert_historicoGraduacoesValuesToTimestamp => return historicoGraduacoes:", returnValue);
  return returnValue;
};
